import { downgradeInjectable } from '@angular/upgrade/static';
import * as angular from 'angular';

import { NgxFeatureFlagService } from './feature-flag.service';
import { ngxLoggerServiceModule } from '@go-modules/services/logger';

export const ngxFeatureFlagServiceModule = angular.module('ngxFeatureFlagServiceModule', [
	ngxLoggerServiceModule
])
	.factory('featureFlag', downgradeInjectable(NgxFeatureFlagService) as any)
	.name;
